import { language as submit_language } from "./submit-express";
let language = {
    ...submit_language,
    RETURN_DETAIL_EMPTY: "Return order does not exist !",
    RETURN_DETAIL_RETURN: "Return Detail",
    RETURN_DETAIL_RETURN_NO: "Return No",
    RETURN_DETAIL_ORDER_NO: "Order No",
    RETURN_DETAIL_RETURN_ITEM: "Return Item",
    RETURN_DETAIL_QUANTITY: "Quantity",
    RETURN_DETAIL_QTY: "Return Qty",
    RETURN_DETAIL_REASON: "Reason",
    RETURN_DETAIL_DESCRIPTION: "Description",
    RETURN_DETAIL_PHOTOS: "Photos",
    RETURN_DETAIL_STATUS: "Status",
    RETURN_DETAIL_CANCEL_RETURN: "Cancel Return",
    RETURN_DETAIL_EXPRESS: "Submit Express",
    RETURN_DETAIL_CLOSE: "Close"
}

export { language }